import "../index.css";
import React from "react";
import { IonIcon } from "@ionic/react";
import { eyeOutline, logoGithub } from "ionicons/icons";
import project2Img from "../assets/wc.webp";

function Projects({ isActive }) {
  const projects = [
    {
      title: "WcGo",
      image: project2Img,
      github: "https://github.com/praveshdev3/wc-go",
      description:
        "CLI tool inspired by Unix wc, built in Go to count bytes, lines, words, and characters from files and stdin.",
      highlights: [
        "Efficient file & stream processing",
        "CLI-based tool with stdin support",
        "Demonstrates Go concurrency & I/O handling",
      ],
      tech: ["Go", "Linux"],
    },
  ];

  return (
    <article
      className={isActive ? "portfolio active" : "portfolio"}
      data-page="portfolio"
    >
      <header>
        <h2 className="h2 article-title">Projects</h2>
      </header>


      <section className="projects">
        <ul className="project-list">
          {projects.map((project, index) => (
            <li key={index} className="project-item active">
              <div className="project-card">
                {/* IMAGE */}
                <figure className="project-img">
                  <img
                    src={project.image}
                    alt={project.title}
                    loading="lazy"
                  />
                </figure>

                {/* CONTENT */}
                <div className="project-content">
                  <div className="project-header">
                    <h3 className="project-title">WcGo</h3>

                    <a
                      href="https://github.com/praveshdev3/wc-go"
                      target="_blank"
                      rel="noreferrer"
                      className="project-github"
                    >
                      <IonIcon icon={logoGithub}></IonIcon>
                    </a>
                  </div>

                  <p className="project-description">
                    CLI tool inspired by Unix <span className="highlight">wc</span>, built in Go to
                    count bytes, lines, words, and characters from files and stdin.
                  </p>

                  <ul className="project-highlights">
                    <li>Efficient file & stream processing</li>
                    <li>CLI tool with stdin support</li>
                    <li>Go concurrency & I/O handling</li>
                  </ul>

                  <div className="project-tags">
                    <span className="tag">Go</span>
                    <span className="tag">Linux</span>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </section>
    </article>
  );
}

export default Projects;